import { render, staticRenderFns } from "./MigrateEmployeesSubscription.vue?vue&type=template&id=a6ca34a6&scoped=true"
import script from "./MigrateEmployeesSubscription.vue?vue&type=script&lang=js"
export * from "./MigrateEmployeesSubscription.vue?vue&type=script&lang=js"
import style0 from "./MigrateEmployeesSubscription.vue?vue&type=style&index=0&id=a6ca34a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6ca34a6",
  null
  
)

export default component.exports